import { AccordionExpandMode as FluentAccordionExpandMode } from "@fluentui/web-components";
/** Expand mode values for {@link Accordion}. */
export const AccordionExpandModes = { ...FluentAccordionExpandMode };
//# sourceMappingURL=accordion.options.js.map